/* eslint-disable react/prop-types */
import { Box } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import Typography from "../../../../components/common/new/Typography/Typography";
import styles from "./CardWithFooter.styles";

function CardWithFooter({
  children,
  title,
  disableViewMore,
  footerText = "View More",
  hideFooter = false,
  minHeight = 0,
  mainContainerStyle = {},
  routeTo,
}) {
  const navigate = useNavigate();

  const onViewMoreClick = () => {
    if (routeTo) {
      navigate(routeTo);
    }
  };
  return (
    <Box style={styles.card}>
      <Box style={styles.title}>
        <Typography weight={600} variant="mini" color="#8C8C8C">
          {title}
        </Typography>
      </Box>
      <Box
        minHeight={minHeight}
        style={{ ...styles.main, ...mainContainerStyle }}
      >
        {children}
      </Box>
      {!hideFooter && (
        <Box style={styles.footer}>
          {!disableViewMore && (
            <Typography
              onClick={onViewMoreClick}
              pointer
              decoration="underline"
              variant="mini"
              weight={500}
              color="#fff"
            >
              {footerText}
            </Typography>
          )}
        </Box>
      )}
    </Box>
  );
}

export default CardWithFooter;
